// messages.js
export default {
    // The key format should be: 'locale.filename'.
    'nl.auth': require('../../lang/nl/auth.php'),
    'en.auth': require('../../lang/en/auth.php'),
    'de.auth': require('../../lang/de/auth.php'),
    'da.auth': require('../../lang/da/auth.php'),
    'fr.auth': require('../../lang/fr/auth.php'),
    'es.auth': require('../../lang/es/auth.php'),
    'nl.portal': require('../../lang/nl/portal.php'),
    'en.portal': require('../../lang/en/portal.php'),
    'de.portal': require('../../lang/de/portal.php'),
    'da.portal': require('../../lang/da/portal.php'),
    'fr.portal': require('../../lang/fr/portal.php'),
    'es.portal': require('../../lang/es/portal.php'),
    'nl.sites': require('../../lang/nl/sites.php'),
    'en.sites': require('../../lang/en/sites.php'),
    'de.sites': require('../../lang/de/sites.php'),
    'da.sites': require('../../lang/da/sites.php'),
    'fr.sites': require('../../lang/fr/sites.php'),
    'es.sites': require('../../lang/es/sites.php'),
    'nl_BE.sites': require('../../lang/nl_BE/sites.php'),
    'fr_BE.sites': require('../../lang/fr_BE/sites.php'),
    'nl.validation': require('../../lang/nl/validation.php'),
    'en.validation': require('../../lang/en/validation.php'),
    'de.validation': require('../../lang/de/validation.php'),
    'da.validation': require('../../lang/da/validation.php'),
    'fr.validation': require('../../lang/fr/validation.php'),
    'es.validation': require('../../lang/es/validation.php'),
}
